import { useMemo } from 'react';
import selectWhyBuyMedia, {
  type SelectedWhyBuyMedia
} from '~/utilities/vdp/selectWhyBuyMedia';
import useWhyBuyData from './useWhyBuyData';

export type WhyBuyNarrativeItem = {
  bulletType?: string;
  content: string;
  id: string;
  media?: SelectedWhyBuyMedia;
  title: string;
};

export default function useWhyBuyNarratives(): Array<WhyBuyNarrativeItem> {
  const { bulletPoints } = useWhyBuyData();

  return useMemo(() => {
    const displayed = (bulletPoints ?? []).flatMap(
      ({ bulletType, content, media, title }, index) =>
        content && title
          ? [
              {
                bulletType,
                content,
                id: `why-buy-narrative-${index}`,
                media,
                title
              }
            ]
          : []
    );
    const selectedMedia = selectWhyBuyMedia(displayed);

    return displayed.map(({ bulletType, content, id, title }, index) => ({
      bulletType,
      content,
      id,
      media: selectedMedia[index],
      title
    }));
  }, [bulletPoints]);
}
